"use client"
import React from "react";
import useApi from "@/components/api/useApi";
import { Formik } from "formik";
import { Form, Button, FormGroup, FormControl } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";

let yup = require("yup");

const SetPasswordForm = props => {
  const emailAddress = props.emailAddress;
  const onSave = props.onSave;

  const api = useApi();
  const randomNumber = api.getRandomInt(10000, 99999);

  const updateProfile = values => {
    var payload = {};

    if (values.password != null) {
      payload["password"] = values.password;
    }

    api
      .updateAccountInfo(emailAddress, payload)
      .then(resp => {
        onSave(true, "Profile Saved!");
      })
      .catch(error => {
        onSave(false, "Something went wrong saving your profile.");
      });
  };

  const equalTo = (ref, msg) => {
    return yup.mixed().test({
      name: "equalTo",
      exclusive: false,
      message: msg || `${ref.path} must be the same as ${ref}`,
      params: {
        reference: ref.path
      },
      test: function(value) {
        return value === this.resolve(ref);
      }
    });
  };

  yup.addMethod(yup.string, "equalTo", equalTo);

  const schema = yup.object({
    password: yup
      .string()
      .min(8)
      .label("Password"),
    verifyPassword: yup
      .string()
      .label("Password")
      .equalTo(yup.ref("password"), "Passwords must match")
  });

  let values = {
    password: "",
    verifyPassword: ""
  };

  return (
    <Formik
      initialValues={values}
      enableReinitialize={true}
      validationSchema={schema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          updateProfile(values);
          setSubmitting(false);
        }, 400);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        isSubmitting,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form
          id={`set-password-form-${randomNumber}`}
          className="no-style"
          onSubmit={handleSubmit}
        >
          <Container>
            <Row>
              <Col>
                <p>
                  Enter a password so you can access your account in the future.
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-group" id="validationFormikPassword">
                  <FormControl
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.password && touched.password}
                    placeholder="Enter Password"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </div>
                <div className="form-group" id="validationFormikVerifyPassword">
                  <FormControl
                    name="verifyPassword"
                    type="password"
                    value={values.verifyPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={
                      !!errors.verifyPassword && touched.verifyPassword
                    }
                    placeholder="Confirm Password"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.verifyPassword}
                  </Form.Control.Feedback>
                  <Form.Text>Password must be at least 8 characters.</Form.Text>
                </div>
                <button
                  style={{ marginTop: "1rem" }}
                  form={`set-password-form-${randomNumber}`}
                  type="submit"
                  disabled={!isValid || isSubmitting}
                  className="btn btn-primary min-size"
                >
                  Set Password
                </button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  );
};
export default SetPasswordForm;
